export const GROUP_LABELS: Record<string, string> = {
  email: 'Email',
  kb: 'Knowledge Base',
  jira: 'Jira',
  calendar: 'Calendar',
  utility: 'Utility',
  system: 'System',
};

export function getGroupLabel(key: string): string {
  return GROUP_LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1);
}
